// Mi Semana v2: prospectos que requieren atención (esperando +N días, pausados con recordatorio).
import React, { useState, useEffect, useCallback, useContext } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { UserContext } from "../contexts/UserContext";
import CRMNav from "./CRMNav";

const BASE = process.env.REACT_APP_API_BASE || "http://localhost/twinpack/php";

const formatFecha = (str) => {
  if (!str) return "—";
  const d = new Date(str);
  if (isNaN(d.getTime())) return "—";
  return `${String(d.getDate()).padStart(2,"0")}/${String(d.getMonth()+1).padStart(2,"0")}/${d.getFullYear()}`;
};

const ProspeccionMiSemana = () => {
  const history = useHistory();
  const { user } = useContext(UserContext);
  const userId = user?.id || JSON.parse(localStorage.getItem("user") || "{}").id;

  const [data, setData] = useState({ esperando_vencidos: [], recordatorios_vencidos: [], umbral_dias: 2 });
  const [loading, setLoading] = useState(true);
  const [soloMisProspectos, setSoloMisProspectos] = useState(false);

  const fetchData = useCallback(() => {
    setLoading(true);
    const fd = new FormData();
    if (soloMisProspectos && userId) fd.append("usuario_id", userId);
    axios.post(`${BASE}/prospectos_mi_semana.php`, fd)
      .then((r) => {
        if (r.data?.success) setData(r.data);
        else toast.error(r.data?.mensaje || "Error al cargar");
      })
      .catch(() => toast.error("Error de conexión"))
      .finally(() => setLoading(false));
  }, [soloMisProspectos, userId]);

  useEffect(() => { fetchData(); }, [fetchData]);

  const totalAlertas = (data.esperando_vencidos?.length || 0) + (data.recordatorios_vencidos?.length || 0);

  return (
    <div style={{ padding: "28px 32px", maxWidth: 980, margin: "0 auto" }}>
      <CRMNav />

      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 22 }}>
        <div>
          <h2 style={{ margin: 0, fontSize: 22, fontWeight: 700 }}>📅 Mi semana</h2>
          <p style={{ margin: "2px 0 0", color: "#888", fontSize: 13 }}>
            {totalAlertas === 0 ? "Sin pendientes por ahora" : `${totalAlertas} ${totalAlertas === 1 ? "prospecto requiere" : "prospectos requieren"} tu atención`}
          </p>
        </div>
        <button onClick={() => history.push("/dashboard/crm/prospeccion")}
          style={{ background: "none", border: "1px solid #e0d6dc", color: "#888", padding: "7px 14px", borderRadius: 6, fontSize: 12, cursor: "pointer" }}>
          ← Volver al embudo
        </button>
      </div>

      <label style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13, color: "#666", marginBottom: 20, cursor: "pointer" }}>
        <input type="checkbox" checked={soloMisProspectos} onChange={(e) => setSoloMisProspectos(e.target.checked)} />
        Solo mis prospectos
      </label>

      {loading ? (
        <p style={{ textAlign: "center", color: "#aaa", padding: 40 }}>Cargando…</p>
      ) : (
        <>
          {/* Esperando vencidos */}
          <div style={{ marginBottom: 30 }}>
            <h3 style={{ margin: "0 0 12px", fontSize: 12, fontWeight: 700, color: "#a16207", textTransform: "uppercase", letterSpacing: "0.08em" }}>
              ⏳ Esperando respuesta hace +{data.umbral_dias} días ({data.esperando_vencidos.length})
            </h3>
            {data.esperando_vencidos.length === 0 ? (
              <p style={{ color: "#bbb", fontSize: 13 }}>— sin pendientes —</p>
            ) : (
              data.esperando_vencidos.map((p) => (
                <div key={`esp-${p.id}`}
                  onClick={() => history.push(`/dashboard/crm/prospeccion/detalle/${p.id}`)}
                  style={{
                    display: "flex", justifyContent: "space-between", alignItems: "center",
                    padding: "12px 16px", background: "#fffbeb",
                    border: "1.5px solid #fbbf24", borderRadius: 8, marginBottom: 6, cursor: "pointer",
                  }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 14, fontWeight: 600, color: "#222" }}>
                      {p.empresa}
                      {p.segmento && <span style={{ color: "#888", fontWeight: 400, fontSize: 12, marginLeft: 8 }}>· {p.segmento}</span>}
                    </div>
                    <div style={{ fontSize: 12, color: "#92400e", marginTop: 2 }}>
                      {p.toques_total} toque{p.toques_total !== 1 ? "s" : ""} · esperando hace {p.dias_esperando} días
                    </div>
                  </div>
                  <div style={{ fontSize: 11, color: "#888", marginLeft: 14 }}>
                    {p.usuario_asignado || "—"}
                  </div>
                </div>
              ))
            )}
          </div>

          {/* Recordatorios vencidos */}
          <div style={{ marginBottom: 30 }}>
            <h3 style={{ margin: "0 0 12px", fontSize: 12, fontWeight: 700, color: "#1d4ed8", textTransform: "uppercase", letterSpacing: "0.08em" }}>
              🔔 Recordatorios pendientes ({data.recordatorios_vencidos.length})
            </h3>
            {data.recordatorios_vencidos.length === 0 ? (
              <p style={{ color: "#bbb", fontSize: 13 }}>— sin recordatorios vencidos —</p>
            ) : (
              data.recordatorios_vencidos.map((p) => (
                <div key={`rec-${p.id}`}
                  onClick={() => history.push(`/dashboard/crm/prospeccion/detalle/${p.id}`)}
                  style={{
                    display: "flex", justifyContent: "space-between", alignItems: "center",
                    padding: "12px 16px", background: "#eff6ff",
                    border: "1.5px solid #93c5fd", borderRadius: 8, marginBottom: 6, cursor: "pointer",
                  }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 14, fontWeight: 600, color: "#222" }}>
                      {p.empresa}
                      {p.segmento && <span style={{ color: "#888", fontWeight: 400, fontSize: 12, marginLeft: 8 }}>· {p.segmento}</span>}
                    </div>
                    <div style={{ fontSize: 12, color: "#1e40af", marginTop: 2 }}>
                      🔔 Retomar desde {formatFecha(p.fecha_recordatorio)}
                      {p.ficha_oportunidad && <span style={{ color: "#666" }}> · {p.ficha_oportunidad}</span>}
                    </div>
                  </div>
                  <div style={{ fontSize: 11, color: "#888", marginLeft: 14 }}>
                    {p.usuario_asignado || "—"}
                  </div>
                </div>
              ))
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default ProspeccionMiSemana;
